import React, { useEffect, useMemo, useState } from "react";
import { MessageSquareQuote, Search, Star } from "lucide-react";
import { instructorApi, apiError } from "../../lib/api";
import { toast } from "sonner";

const fmt = (d) => { try { const s = typeof d === "string" && !/[zZ]|[+-]\d\d:\d\d$/.test(d) ? `${d}Z` : d; return new Date(s).toLocaleString("es-MX", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }); } catch { return ""; } };

const Respuesta = ({ q, v }) => q.tipo === "escala" ? (
  <div className="flex items-center justify-between gap-3 rounded-lg bg-[#F4F6F9] px-3 py-2">
    <span className="text-xs text-[#2A3446]">{q.label}</span>
    <span className="flex items-center gap-0.5 shrink-0">{[1, 2, 3, 4, 5].map((n) => <Star key={n} className={`w-3.5 h-3.5 ${n <= Number(v) ? "fill-[var(--gold)] text-[var(--gold)]" : "text-[#C7CDD6]"}`} />)}<b className="ml-1 text-xs text-[#0A1C30]">{v || "—"}</b></span>
  </div>
) : (
  <div className="rounded-lg bg-[#FFF7E6] px-3 py-2">
    <p className="text-[11px] font-bold text-[#8A6A12]">{q.label}</p>
    <p className="text-sm text-[#2A3446] mt-0.5 whitespace-pre-wrap">{v || <span className="text-[#9AA3B2]">Sin comentario</span>}</p>
  </div>
);

export const EncuestasAlumnos = () => {
  const [d, setD] = useState(null);
  const [q, setQ] = useState("");
  useEffect(() => { instructorApi.encuestasAlumnos().then(setD).catch((e) => { toast.error(apiError(e)); setD({ preguntas: [], items: [] }); }); }, []);
  const items = useMemo(() => (d?.items || []).filter((e) => `${e.alumno} ${e.clase_titulo} ${e.materia_nombre}`.toLowerCase().includes(q.toLowerCase())), [d, q]);
  if (!d) return null;
  return (
    <div className="mt-6" data-testid="encuestas-alumnos">
      <h3 className="font-extrabold text-[#0A1C30] flex items-center gap-2"><MessageSquareQuote className="w-5 h-5 text-[#7B3FBF]" /> Encuestas de mis alumnos <span className="text-xs font-bold text-[#6B7688]">({d.items.length})</span></h3>
      {d.items.length === 0 ? (
        <div className="mt-3 bg-white rounded-2xl ring-1 ring-black/5 p-8 text-center text-[#6B7688] font-semibold" data-testid="encuestas-alumnos-empty">Aún no hay encuestas de tus alumnos. Aparecerán aquí en cuanto evalúen tus clases.</div>
      ) : (
        <>
          <div className="mt-3 relative max-w-sm"><Search className="w-4 h-4 text-[#9AA3B2] absolute left-3 top-1/2 -translate-y-1/2" /><input data-testid="encuestas-alumnos-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar alumno, clase o materia" className="w-full rounded-xl ring-1 ring-black/10 pl-9 pr-3 py-2 text-sm bg-white" /></div>
          <div className="mt-3 space-y-3">
            {items.map((e) => (
              <div key={e.id} className="bg-white rounded-2xl ring-1 ring-black/5 p-4" data-testid={`encuesta-alumno-${e.id}`}>
                <div className="flex flex-wrap items-start justify-between gap-2">
                  <div>
                    <p className="font-extrabold text-[#0A1C30] text-sm">{e.alumno || "Alumno"} <span className="text-xs font-semibold text-[#6B7688]">· {e.programa}</span></p>
                    <p className="text-xs text-[#6B7688] mt-0.5"><b className="text-[#2A3446]">Clase:</b> {e.clase_titulo}{e.materia_nombre ? <> · <b className="text-[#2A3446]">Materia:</b> {e.materia_nombre}</> : null}{e.clase_fecha ? ` · ${e.clase_fecha}` : ""}</p>
                  </div>
                  <span className="text-[11px] text-[#9AA3B2]">{fmt(e.submitted_at)}</span>
                </div>
                <div className="mt-3 grid gap-2">{d.preguntas.map((p) => <Respuesta key={p.id} q={p} v={e.respuestas?.[p.id]} />)}</div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};
